"use client";

import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDIYFilterOption } from "~/app/[lang]/(default)/overview/[type]/[id]/DIYListing/useDIYListing";
import { Link } from "~/components/Link";
import type { DIYAggregation } from "~/graphql/shared/page";

interface ActiveFilterProps {
	aggregation: DIYAggregation;
	option: DIYAggregation["options"][number];
}

export function ActiveFilter({ aggregation, option }: ActiveFilterProps) {
	const { href, isActive } = useDIYFilterOption({ aggregation, option });

	if (!isActive) {
		return null;
	}

	return (
		<Link
			className="flex items-center space-x-2 rounded bg-primary-dark px-4 py-1 text-white transition-all hover:bg-primary-medium"
			href={href}
		>
			<span>{option.label}</span>

			<FontAwesomeIcon icon={faTimes} className="block text-sm" />
		</Link>
	);
}
